import { LoginService, UserLoginHistoryService } from '@mango/authentication';
import { AlertService } from './alert/alert.service';
import { UserService } from './user/user.service';
import { DashboardService } from './dashboard/dashboard.service';
import { SupportService } from './support/support.service';
import { PrijscorrectieService } from './cij/prijscorrectie/prijscorrectie.service';
import { ExactService } from './cij/exact/exact.service';
import { TabService } from './core/service/tab.service';
import { PrijscorrectieArtikelService } from './cij/prijscorrectieArtikel/prijscorrectieArtikel.service';

export const services = [
    LoginService,
    AlertService,
    UserService,
    DashboardService,
    SupportService,
    PrijscorrectieService,
    PrijscorrectieArtikelService,
    UserLoginHistoryService,
    ExactService,
    TabService
]